import { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import RFField from "../../../Form/RFField";
import RFForm from "../../../Form/RFForm";
import { useEditorContext } from "../../Wysiwyg";
import ToolbarItem from "../ToolbarItem";

const alignedTableMetadata = {
  left: {
    className: "align-left",
    tooltip: "Balra igazított táblázat",
    icon: <i className="fa fa-align-left" aria-hidden="true" />,
  },
  center: {
    className: "align-center",
    tooltip: "Középre igazított táblázat",
    icon: <i className="fa fa-align-center" aria-hidden="true" />,
  },
  right: {
    className: "align-right",
    tooltip: "Jobbra igazított táblázat",
    icon: <i className="fa fa-align-right" aria-hidden="true" />,
  },
};

const ToolbarTable = ({ align }) => {
  const { editor } = useEditorContext();

  const tableMetadata = alignedTableMetadata[align];
  const [modal, setModal] = useState(false);

  const [columns, setColumns] = useState("");
  const [rows, setRows] = useState("");
  const [withHeaderRow, setWithHeaderRow] = useState(true);
  const [classNames, setClassNames] = useState("");

  const toggle = () => {
    setModal(!modal);
    setColumns("");
    setRows("");
    setClassNames("");
    setWithHeaderRow(true);
  };

  const handleSubmit = () => {
    const tableHTML = `
      <table class="${tableMetadata?.className} ${classNames}">
        ${Array.from({ length: rows })
          .fill("")
          .map((_, i) => {
            const thOrTd = i === 0 && withHeaderRow ? "th" : "td";
            return `<tr>
                ${Array.from({ length: columns })
                  .fill(
                    `<${thOrTd}>
                      <p style="text-align: ${align ?? "left"}"></p>
                    </${thOrTd}>`
                  )
                  .join("")}
              </tr>`;
          })
          .join("")}
      </table>
    `;

    editor
      .chain()
      .focus()
      .insertContent(tableHTML, {
        parseOptions: { preserveWhitespace: false },
      })
      .run();

    toggle();
  };

  return (
    <>
      <ToolbarItem
        id={`table-${tableMetadata?.className ?? "regular"}`}
        tooltip={tableMetadata?.tooltip ?? "Táblázat"}
        active={false}
        onToggle={toggle}
        icon={
          <>
            <i className="fa fa-table" aria-hidden="true" />{" "}
            {tableMetadata?.icon}
          </>
        }
      />

      <Modal isOpen={modal} toggle={toggle} backdrop="static">
        <RFForm onSubmit={handleSubmit}>
          <ModalHeader toggle={toggle}>Táblázat beszúrása</ModalHeader>
          <ModalBody>
            <RFField
              id="columns"
              name="columns"
              type="text"
              label="Oszlopok száma"
              value={columns}
              onChange={(e, v) => setColumns(v)}
              required
            />
            <RFField
              id="rows"
              name="rows"
              type="text"
              label="Sorok száma"
              value={rows}
              onChange={(e, v) => setRows(v)}
              required
            />
            <RFField
              id="classNames"
              name="classNames"
              type="text"
              label="Táblázat osztályneve(i)"
              value={classNames}
              onChange={(e, v) => setClassNames(v)}
            />
            <RFField
              id="withHeaderRow"
              name="withHeaderRow"
              type="checkbox"
              label="Az első sor legyen fejléc"
              value={withHeaderRow}
              onChange={(e) => setWithHeaderRow(e.target.checked)}
              required
            />
          </ModalBody>
          <ModalFooter>
            <Button color="primary">OK</Button>{" "}
            <Button color="secondary" onClick={toggle}>
              Mégsem
            </Button>
          </ModalFooter>
        </RFForm>
      </Modal>
    </>
  );
};

export default ToolbarTable;
